import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { finalize, tap } from 'rxjs';
import { StudentClassAssignmentHttpService } from './student-class-assignment-http.service';
import { StudentClassAssignmentHttpModel, StudentClassAssignmentStoreModel } from './student-class-assignment.model';
import { StudentClassAssignmentStore } from './student-class-assignment.store';

@Injectable({ providedIn: 'root' })
export class StudentClassAssignmentService {
  constructor(
    private readonly store: StudentClassAssignmentStore,
    private readonly http: StudentClassAssignmentHttpService,
    private readonly errorHandler: ErrorHandlerService,
  ) {}

  fetchByClassId(
    classId: string,
    { resetStore, showLoading }: { resetStore?: boolean; showLoading?: boolean } = { resetStore: false },
  ) {
    if (resetStore) {
      this.store.reset();
    }

    if (resetStore || showLoading) {
      this.store.setLoading(true);
    }

    return this.http.fetchByClassId(classId).pipe(
      this.errorHandler.setHttpErrorMetadata({ entity: 'student_class_assignment', action: 'fetch' }),
      tap((assignments) => {
        const storeModels = assignments.map((a) => this.mapToStoreModel(a));
        if (resetStore) {
          this.store.set(storeModels);
        } else {
          this.store.upsertMany(storeModels);
        }
      }),
      finalize(() => {
        if (resetStore || showLoading) {
          this.store.setLoading(false);
        }
      }),
    );
  }

  resetStore() {
    this.store.reset();
  }

  private mapToStoreModel(httpModel: StudentClassAssignmentHttpModel): StudentClassAssignmentStoreModel {
    return {
      ...httpModel,
      assignment_id: httpModel.assignment_id ?? '',
      class_id: httpModel.class_id ?? '',
      assignment_name: httpModel.assignment_name ?? '',
    };
  }
}
